// themes/devastators/index.js
//
// Central export point for the Devastators theme
// Bundles theme configuration, events, and story content

import devastatorsTheme from './devastatorsTheme.js';
import devastatorsEventsLibrary from './devastatorsEvents.js';
import devastatorsStoryLibrary from './devastatorsStory.js';

/**
 * Devastators Theme Bundle
 * Contains all configuration, content libraries, and narrative data
 * for the post-apocalyptic diesel-punk Devastators universe
 */
const devastatorsBundle = {
  // Theme configuration - visual, UI, and gameplay formatting
  theme: devastatorsTheme,
  
  // Event content library - backdrop, threat, morale, faction, discovery, campaign events
  events: devastatorsEventsLibrary,
  
  // Story content library - 4-chapter narrative arc and story threads
  story: devastatorsStoryLibrary
};

export default devastatorsBundle;

// Named exports for flexibility
export { devastatorsTheme, devastatorsEventsLibrary, devastatorsStoryLibrary };